// src/components/orders/DestinationSelector.js - Selettore destinazione per clienti con più indirizzi
import React from 'react';
import { MapPin, Building } from 'lucide-react';

const DestinationSelector = ({ customer, selectedDestination, onDestinationChange }) => {
  if (!customer || !customer.destinations || customer.destinations.length === 0) {
    return null; // Non mostrare se non ci sono destinazioni extra
  }

  // Aggiungi l'indirizzo principale come prima opzione
  const allDestinations = [
    {
      index: 'main',
      name: 'Sede Principale',
      address: customer.legalAddress,
      city: customer.city,
      province: customer.province,
      postalCode: customer.zipCode
    },
    ...customer.destinations.map((dest, index) => ({ ...dest, index }))
  ];

  return (
    <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
      <div className="flex items-center space-x-2 mb-3">
        <MapPin className="w-5 h-5 text-amber-600" />
        <h3 className="text-sm font-medium text-amber-900">
          Seleziona Destinazione
        </h3>
      </div>
      
      <p className="text-xs text-amber-700 mb-3">
        Questo cliente ha più indirizzi di consegna. Seleziona la destinazione per questo ordine:
      </p>

      <div className="space-y-2">
        {allDestinations.map((destination) => (
          <label
            key={destination.index}
            className={`flex items-start space-x-3 p-3 border rounded-lg cursor-pointer transition-colors ${
              selectedDestination?.index === destination.index
                ? 'border-blue-500 bg-blue-50'
                : 'border-gray-200 hover:border-blue-300 hover:bg-blue-25'
            }`}
          >
            <input
              type="radio"
              name="destination"
              value={destination.index}
              checked={selectedDestination?.index === destination.index}
              onChange={() => onDestinationChange(destination)}
              className="mt-1 text-blue-600"
            />
            <div className="flex-1 min-w-0">
              <div className="flex items-center space-x-2 mb-1">
                <Building className="w-4 h-4 text-gray-500" />
                <span className="text-sm font-medium text-gray-900">
                  {destination.name}
                </span>
              </div>
              <div className="text-sm text-gray-600">
                {destination.address}
                {destination.city && (
                  <span>, {destination.city}</span>
                )}
                {destination.postalCode && (
                  <span> - {destination.postalCode}</span>
                )}
                {destination.province && (
                  <span> ({destination.province})</span>
                )}
              </div>
            </div>
          </label>
        ))}
      </div>

      {!selectedDestination && (
        <div className="mt-3 p-2 bg-red-50 border border-red-200 rounded text-sm text-red-700">
          ⚠️ Seleziona una destinazione per continuare
        </div>
      )}
    </div>
  );
};

export default DestinationSelector;